export default __webpack_public_path__ + "9fb86a34c8daa087a0616cfbade7abf1.png";